import React from "react";
import useScrollAnimation from "../hooks/useScrollAnimation";
import "./PageHero.css";

export default function PageHero({ eyebrow, title, subtitle }) {
  const lines = Array.isArray(title) ? title : [title];

  const sectionRef = useScrollAnimation(({ gsap, el }) => {
    gsap.from(el.querySelectorAll(".page-hero__title span"), {
      yPercent: 110,
      opacity: 0,
      duration: 0.8,
      stagger: 0.08,
      ease: "power4.out",
    });
    gsap.from(el.querySelector(".page-hero__subtitle"), {
      opacity: 0,
      y: 20,
      duration: 0.7,
      delay: 0.3,
      ease: "power3.out",
    });
  }, []);

  return (
    <section className="page-hero" ref={sectionRef}>
      <div className="page-hero__glow" aria-hidden="true" />
      <div className="container">
        {eyebrow && <span className="eyebrow">{eyebrow}</span>}
        <h1 className="page-hero__title">
          {lines.map((line, i) => (
            <span key={i}>{line}</span>
          ))}
        </h1>
        {subtitle && <p className="page-hero__subtitle">{subtitle}</p>}
      </div>
    </section>
  );
}
